import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { BiGrupoUsuario } from 'pages/bi/types';

export function BiGrupoUsuarioAutoComplete({
    sx,
    name,
    value,
    error,
    size,
    queryKey,
    multiple = false,
    disabled = false,
    onChange = () => {},
    label = 'Grupo de usuários',
}: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            objectId="idGrupoUsuario"
            optionStringTemplate="{dsGrupoUsuario}"
            selectedStringTemplate="{dsGrupoUsuario}"
            sx={sx}
            size={size}
            name={name}
            label={label}
            value={value}
            error={error}
            queryKey={queryKey}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            isOptionEqualToValue={(option: BiGrupoUsuario, value: BiGrupoUsuario) => option.idGrupoUsuario === value.idGrupoUsuario}
            requestOptions={{
                url: '/gestao/grupousuario',
                sort: [{ property: 'idGrupoUsuario', direction: 'ASC' }],
                limit: 50,
            }}
        />
    );
}
